import type { AppProps } from "next/app";
import { FeatureFlagsProvider } from "@/flags/flags";
import "../globals.scss";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <FeatureFlagsProvider
      experiencesRawString={pageProps.experiencesRawString}
      flags={pageProps.flags}
      id="web-plp-scaffold-ui"
    >
      <Component {...pageProps} />
    </FeatureFlagsProvider>
  );
}
